<template>
  <div class="c-blockquote">
    <div
      class="c-blockquote__info"
      v-if="
        fields &&
        fields.heading &&
        fields.desc &&
        fields.cta &&
        fields.ctaVideoCta &&
        fields.ctaVideoCode
      "
    >
      <sc-text
        tag="h2"
        class="c-blockquote__title"
        v-if="fields && fields.heading"
        :field="fields.heading"
      />
      <sc-text
        tag="p"
        class="c-blockquote__desc"
        v-if="fields && fields.desc"
        :field="fields.desc"
      />
      <sc-link
        v-if="fields && fields.cta && fields.cta.value && fields.cta.value.text"
        :field="fields.cta"
        class="c-cta--secondary"
        :class="fields.cta.value.class"
      />
      <span
        v-if="
          fields &&
          fields.ctaVideoCode &&
          fields.ctaVideoCta &&
          fields.ctaVideoCode.value &&
          fields.ctaVideoCta.value
        "
        :class="`wistia_embed wistia_async_${fields.ctaVideoCode.value} popover=true popoverContent=link`"
        style="display: block; position: relative"
      >
        <a class="c-cta--secondary">{{ fields.ctaVideoCta.value }}</a>
      </span>
    </div>
    <div
      class="c-blockquote__quote"
      :class="{
        'full-width':
          fields.heading.value === '' &&
          fields.desc.value === '' &&
          fields.cta.value.href === '' &&
          fields.ctaVideoCode.value === '' &&
          fields.ctaVideoCta.value === ''
      }"
    >
      <sc-text tag="div" class="quote" v-if="fields && fields.quote" :field="fields.quote" />
      <sc-text tag="div" class="quote__name" v-if="fields && fields.name" :field="fields.name" />
      <sc-text class="quote__title" v-if="fields && fields.title" :field="fields.title" />
    </div>
  </div>
</template>

<script>
import { Text, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Blockquote',
  components: {
    ScText: Text,
    ScLink: Link
  },
  props: {
    fields: {
      type: Object
    }
  },
  mounted() {
    if (this.fields.ctaVideoCode) {
      let wistiaJsonp = document.createElement('script');
      wistiaJsonp.setAttribute(
        'src',
        'https://fast.wistia.com/embed/medias/' + this.fields.ctaVideoCode + '.jsonp'
      );
      document.head.appendChild(wistiaJsonp);
    }

    let wistiaScript = document.createElement('script');
    wistiaScript.setAttribute('src', 'https://fast.wistia.com/assets/external/E-v1.js');
    document.head.appendChild(wistiaScript);
  }
};
</script>
<style lang="scss">
.c-blockquote {
  padding: 3rem 0;

  @include tablet-up {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  &__info {
    width: 100%;

    @include tablet-up {
      width: calc(40% - 6rem);
      margin-right: 6rem;
    }

    .c-blockquote__title {
      font-size: 2rem;
      font-weight: 200;
      line-height: 2.6rem;
      margin-bottom: 0;
      margin-bottom: 1.5rem;

      @include tablet-up {
        font-size: 2.8rem;
        line-height: 3.5rem;
      }
    }

    .c-blockquote__desc {
      font-size: 2rem;
      line-height: 2.8rem;

      @include tablet-up {
        font-size: 2rem;
        line-height: 2.8rem;
      }
    }
  }

  &__quote {
    position: relative;
    width: 100%;
    padding-left: 4.5rem;
    padding-right: 2rem;

    @include tablet-up {
      width: 60%;
      padding-left: 8rem;
      padding-right: 0;
    }

    &.full-width {
      width: 100%;
    }

    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 0.8rem;
      left: 0;
      width: 2.95rem;
      height: 2.27rem;
      background-size: cover;
      -webkit-mask: url(~@/assets/images/hp_blockquote.png);
      mask: url(~@/assets/images/hp_blockquote.png);
      mask-size: cover;
      background-color: $orange;

      @include tablet-up {
        top: 1rem;
        width: 5.2rem;
        height: 4rem;
      }
    }

    .quote {
      font-size: 1.8rem;
      line-height: 2.4rem;
      font-style: italic;
      color: $dark-blue;
      margin-bottom: 2rem;
      font-weight: 200;

      @include tablet-up {
        font-size: 2.4rem;
        line-height: 3.5rem;
      }

      &__name {
        font-size: 1.6rem;
        line-height: 2rem;
        font-weight: 500;
        color: $dark-blue;

        @include tablet-up {
          font-size: 1.8rem;
          line-height: 2.4rem;
        }
      }

      &__title {
        font-size: 1.6rem;
        line-height: 2rem;
        font-weight: 200;
        color: $dark-blue;

        @include tablet-up {
          font-size: 1.8rem;
          line-height: 2.4rem;
        }
      }
    }
  }
}

.c-blockquote {
  &-item {
    padding-bottom: 2rem;

    &__title,
    &__organization {
      font-size: 1.6rem;
      line-height: 2rem;
      font-weight: 200;
      color: $dark-blue;

      @include tablet-up {
        font-size: 2rem;
        line-height: 2.6rem;
      }
    }
  }
}
</style>
